// __webpack_public_path__ needs to be set in own file
// see https://github.com/webpack/webpack/issues/2776

import logger from 'saddlebag-logger';

let publicPath;
try {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-underscore-dangle
    publicPath = window.__internal.publicPath;
  }
} catch (e) {
  logger.logError(e, {
    message: `Error in webpack bundle bootstrapping: ${e.message}`,
    component: 'falcon.public-path',
    url: window.location.href,
    error: e.stack,
  });
  throw e;
}

// eslint-disable-next-line camelcase, no-undef
__webpack_public_path__ = publicPath;
